import Vue from 'vue'
// 导入组件
import showFileDetailDialog from './Dialog.vue'
// 使用基础 Vue 构造器，创建一个“子类”
const ShowFileDetailConstructor = Vue.extend(showFileDetailDialog)

let showFileDetailInstance = null
/**
 * 初始化文件详情文件实例
 * @param {object | array} fileInfo 文件信息，批量时为数组、单文件时为对象
 */
const initInstanceShowFileDetail = (fileInfo) => {
	showFileDetailInstance = new ShowFileDetailConstructor({
		el: document.createElement('div'),
		data () {
			return {
				fileInfo
			}
		}
	})
}
/**
 * 文件详情文件 Promise 函数
 * @returns {Promise} 抛出确认和取消回调函数
 */
export default (obj) => {
	// 非首次调用服务时，在 DOM 中移除上个实例
	if (showFileDetailInstance !== null) {
		document.body.removeChild(showFileDetailInstance.$el)
	}
	let { fileInfo } = obj
	return new Promise((reslove) => {
		initInstanceShowFileDetail(fileInfo)
		showFileDetailInstance.callback = (res) => {
			reslove(res)
			// 服务取消时卸载 DOM
			if (res === 'cancel' && showFileDetailInstance !== null) {
				document.body.removeChild(showFileDetailInstance.$el)
				showFileDetailInstance = null
			}
		}
		document.body.appendChild(showFileDetailInstance.$el) //  挂载 DOM
		Vue.nextTick(() => {
			showFileDetailInstance.visible = true //  打开对话框
		})
	})
}
